import axios from 'axios';

import { API as customBaseURL } from 'config_app';
import { SERVICE_TIMEOUT as timeout } from 'constants/system';

import addAuthenticationInterceptors from 'core/axios/interceptors/addAuthenticationInterceptors';
import addJwtInterceptor from 'core/axios/interceptors/addJwtInterceptor';
import addLanguageInterceptor from 'core/axios/interceptors/addLanguageInterceptor';
import addLocalhostEnvCookie from 'core/axios/interceptors/addLocalhostEnvCookie';
import addPayloadCasingInterceptors from 'core/axios/interceptors/addPayloadCasingInterceptors';
import addRateLimitInterceptor from 'core/axios/interceptors/addRateLimitInterceptor';
import addSentryTimeoutInterceptor from 'core/axios/interceptors/addSentryTimeoutInterceptor';
import addUnauthorizedInterceptor from 'core/axios/interceptors/addUnauthorizedInterceptor';
import addURLSlashesInterceptors from 'core/axios/interceptors/addURLSlashesInterceptors';

import paramsSerializer from 'core/axios/paramsSerializer';

const createClient = ({
  baseURL = `${customBaseURL}/api/`,
  oauth2 = false,
  unauthorizedInterceptor = true,
} = {}) => {
  const client = axios.create({
    timeout,
    baseURL,
    headers: {
      'Content-Type': 'application/json',
      'User-Timezone': Intl.DateTimeFormat().resolvedOptions().timeZone,
    },
    withCredentials: !oauth2,
    paramsSerializer: {
      serialize: paramsSerializer,
    },
  });

  if (!oauth2) {
    addAuthenticationInterceptors(client);
  }
  if (unauthorizedInterceptor) {
    addUnauthorizedInterceptor(client);
  }

  addPayloadCasingInterceptors(client);
  addURLSlashesInterceptors(client);
  addLocalhostEnvCookie(client);
  addRateLimitInterceptor(client);
  addSentryTimeoutInterceptor(client);
  addLanguageInterceptor(client);

  addJwtInterceptor();

  return client;
};

// @TODO: retry with gauss curve - check axios-retry maybe?

export default createClient();
export { createClient };
